<template>
  <v-container fluid class="pa-5 pb-16 elevation-1">
    <!-- HEADER -->
     <v-sheet class="pa-4 w-100 app-header" color="#194c9b" elevation="2" rounded>
      <h1 class="text-h4 font-weight-bold d-flex align-center">
        <div class="header-content">
            <v-btn
              v-bind="props"
              icon
              elevation="2"
              color="blue"
            >
              <v-img
              v-bind="props"
              :src="chatgptIcon"
              class="header-icon cursor-pointer"
              color="black"
              contain
              />
            </v-btn>
            <span class="header-title">ChatGPT</span>
        </div>
      </h1>
    </v-sheet>
    <!-- CONTENIDO -->
    <v-card>
      <!-- FILTROS -->
      <v-card class="filters cool-card">
        <div class="filter-gorup">
          <label>{{ $t("buscar") }}</label>
          <v-text-field
            v-model.trim="search"
            :placeholder="$t('input_filtro')"
            variant="outlined"
            density="comfortable"
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
          />
        </div>

        <div class="filter-actions">
          <v-btn variant="elevated" color="primary" size="large" rounded="x1" @click="onCrear">
            {{ $t("nuevo_proyecto") }}
          </v-btn>
        </div>
      </v-card>

      <!-- sin proyectos -->
      <v-empty-state
        v-if="projects.length === 0"
        icon="mdi-folder-outline"
        :title="$t('no_proyectos')"
        :text="$t('no_proyectos_msg')"
      >
        <template #actions>
          <v-btn color="primary" rounded="lg" size="large" @click="onCrear">
            + {{ $t("nuevo_proyecto") }}
          </v-btn>
        </template>
      </v-empty-state>

      <!-- TABLA -->
      <template v-else>
        <!-- filtros -->
        <v-empty-state
          v-if="projects.length > 0 && filteredProjects.length === 0"
          icon="mdi-magnify"
          :title="$t('no_resultados')"
          :text="$t('no_resultados_msg')"
        >
          <template #actions>
            <v-btn variant="tonal" color="primary" rounded="lg" @click="clearFilters">
              {{ $t("filtros") }}
            </v-btn>
          </template>
        </v-empty-state>
        <v-card v-else rounded="lg" variant="outlined" class="cool-card table-card">
          <v-table class="pro-table" hover>
          <thead>
            <tr>
              <th class="col-proyecto">{{ $t('project') }}</th>
                <th class="col-estado">{{ $t('Estado') }}</th>
                <th class="col-qalead">{{ $t('QA_Lead') }}</th>
                <th class="col-tipo">{{ $t('Tipo_proyecto') }}</th>
                <th class="col-actual">{{ $t('actualizacion') }}</th>
                <th class="col-acciones text-center">{{ $t('Acciones') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="p in filteredProjects" :key="p.idProyect">
              <td>
                <div class="project-title">{{ p.nombre }}</div>
                <div class="project-meta">
                  ID: {{ p.clave }} · {{ $t("cliente") }} {{ p.cliente }}
                </div>
              </td>

              <td>
                <span class="status" :class="statusClass(p.estado)">
                  <span class="dot"></span> {{ p.estado }}
                </span>
              </td>

              <td>{{ p.qaLead }}</td>
              <td>{{ p.tipo }}</td>
              <td>{{ p.actualizacion }}</td>

              <td class="text-center">
                <div class="actions actions--table">
                  <!-- Editar -->
                  <v-tooltip text="Editar proyecto" location="top">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        elevation="2"
                        class="action-btn"
                        @click="openEdit(p)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>

                  <!-- Open Chat (ChatGPT icon) -->
                  <v-tooltip text="Abrir ChatGPT" location="top">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        elevation="2"
                        class="action-btn"
                        @click="openChat(p)"
                      >
                        <v-img
                          :src="chatgptIcon"
                          class="chatgpt-icon"
                          contain
                        />
                      </v-btn>
                    </template>
                  </v-tooltip>

                  <!-- Eliminar -->
                  <v-tooltip text="Eliminar proyecto" location="top">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        elevation="2"
                        class="action-btn"
                        @click="openDelete(p)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </td>
              </tr>
            </tbody>
          </v-table>
          <!-- FOOTER / PAGINACIÓN -->
          <v-divider class="my-4" />

          <div class="d-flex align-center justify-space-between flex-wrap ga-3 px-4 pb-4 table-footer">
            <div class="d-flex align-center ga-2">
              <span class="text-caption text-medium-emphasis">
                {{ $t("paginacion") }}
              </span>

              <v-select
                v-model="itemsPerPage"
                :items="[5, 8, 10, 20]"
                density="compact"
                variant="outlined"
                hide-details
                class="items-select"
                style="max-width: 110px;"
              />
            </div>

            <v-pagination
              v-model="page"
              :length="pageCount"
              density="comfortable"
              :total-visible="6"
            />
          </div>
        </v-card>
      </template>
    </v-card>
    <!-- MODAL: Crear Proyecto -->
    <NuevoProyectoGPT
      v-model="crearDialog"
      mode="create"
      @save="onSaveProject"
    />

    <!-- MODAL EDITAR -->
    <NuevoProyectoGPT
      v-model="editDialog"
      mode="edit"
      :project="selectedProject"
      :key="selectedProject?.idProyect || 'edit'"
      @save="onUpdateProject"
    />

    <!-- MODAL ELIMINAR -->
    <DeleteProyectoGPT
      v-model="deleteDialog"
      :project="projectToDelete"
      @deleted="fetchProjects"
    />
</v-container>
</template>
<script>
import '@/css/Proyectos/StyleTableProyect.css'
import '@/css/ChatGPT/StyleChatGPT.css'
import chatgptIcon from '@/assets/chatgpt.png'
import NuevoProyectoGPT from './NuevoProyectoGPT.vue';
import DeleteProyectoGPT from './DeleteProyectoGPT.vue';
import {
  getUnitBussines,
  getProjectsChatGPT,
  getProyectoDetail,
} from "@/api/proyectos.js";
export default {
  name: 'ChatGPT',
  components: { NuevoProyectoGPT, DeleteProyectoGPT },
  data() {
    return {
        chatgptIcon,
        crearDialog: false,
        search: '',
        estado: '',
        page: 1,
        itemsPerPage: 5,
        idProyect: null,
        deleteDialog:false,
        projectToDelete:null,
        editDialog: false,
        selectedProject: null,
        tipo: '',
        projects: [],
        loadingProjects: false,  
        unitMap: {}        
        }
    },
    async mounted() {
      await this.fetchUnits()
      await this.fetchProjects()
    },
    computed: {
      filteredProjects() {
      const q = this.search.toLowerCase()

      return this.projects.filter(p => {
          const matchesSearch =
          !q ||
          p.nombre.toLowerCase().includes(q) ||
          p.clave.toLowerCase().includes(q) ||
          p.qaLead.toLowerCase().includes(q) ||
          p.cliente.toLowerCase().includes(q) ||
          p.tipo.toLowerCase().includes(q) ||
          p.estado.toLowerCase().includes(q)

          const matchesEstado = !this.estado || p.estado === this.estado
          const matchesTipo = !this.tipo || p.tipo === this.tipo

          return matchesSearch && matchesEstado && matchesTipo
      })
      },
      pageCount() {
        const total = this.filteredProjects.length
        const per = Number(this.itemsPerPage) || 8
        return Math.max(1, Math.ceil(total / per))
      },

      pagedProjects() {
        const per = Number(this.itemsPerPage) || 8
        const start = (this.page - 1) * per
        return this.filteredProjects.slice(start, start + per)
      }
    },
    watch: {
      search() { this.page = 1 },
      estado() { this.page = 1 },
      tipo() { this.page = 1 },
      itemsPerPage() { this.page = 1 },
      projects() { this.page = 1 },
    },
    methods: {
      openDelete(p){
        this.projectToDelete = p
        this.deleteDialog = true
      },
      confirmDelete(project){
        this.projects = this.projects.filter(p => p.idProyect !== project.idProyect)
      },
      async openEdit(p) {
        const pk = p.idProyect || p.clave || p.id
        if (!pk) return

        this.editDialog = true
        this.selectedProject = p.raw ? JSON.parse(JSON.stringify(p.raw)) : p

        try {
          const detail = await getProyectoDetail(pk)
          if (detail) this.selectedProject = detail
        } catch (e) {
          return
        }
      },
      async onUpdateProject() {
        await this.fetchProjects()
      },
      statusClass(estado) {
        if (estado === 'En curso') return 'en-curso'
        if (estado === 'Nuevo') return 'nuevo'
        return 'mantenimiento'
      },

      clearFilters() {
        this.search = ''
        this.estado = ''
        this.tipo = ''
      },

      onExportar() {
        //console.log('Exportar', this.filteredProjects)
      },

      onCrear() {
        this.crearDialog = true
      },
      openChat(p) {
        const pk = p.clave || p.idProyect || p.id
        this.$router.push({ name: "Chat", params: { clave: pk } })
      },
      async  onSaveProject() {
        await this.fetchProjects()
      },
      async fetchUnits() {
        try {
          const data = await getUnitBussines()
          this.unitMap = Object.fromEntries(
            (data || []).map(u => [u.id, u.nameUnitBussines])
          )
        } catch (e) {
          this.unitMap = {}
        }
      },

      mapProjectFromApi(p) {
        return {
          idProyect: p.idProyect,                                 
          nombre: p.nameProyect ?? "",
          clave: p.idProyect ?? "",
          cliente: this.unitMap[p.UnitBussines] ?? "",   
          estado: p.status ?? "Nuevo",
          qaLead: p.accountable ?? "",
          tipo: p.typeProject ?? p.typeProject ?? "",     
          actualizacion: p.updatedAt ?? "Hoy",            

          raw: p
        }
      },

      async fetchProjects() {
        this.loadingProjects = true
        try {
          const data = await getProjectsChatGPT()
          this.projects = (data || []).map(this.mapProjectFromApi)
        } catch (e) {
          this.projects = []
        } finally {
          this.loadingProjects = false
        }
      },
      }
    }
</script>
